import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Typography, Button } from '@mui/material';
import Breadcrumb from 'src/components/Breadcrumb';
import { useDispatch, useSelector } from 'react-redux';
import { GetApp, FilterList } from '@mui/icons-material';
import Filter from 'src/components/Filter/Filter';
import FILTER_TYPES from 'src/utils/constants/filter';
import useStyles from '../capitalBalance/components/styles';

const filters = [
  {
    title: 'COMMON.DATE',
    controlGroup: FILTER_TYPES.DATE,
    items: [
      {
        label: 'COMMON.DATE',
        value: 'date',
        view: ['year', 'month']
      }
    ]
  }
];

function getFilterOptions(options) {
  let month = null;
  let year = null;
  if (options.date) {
    month = options.date.month() + 1;
    year = options.date.year();
  }
  return { year, month };
}

const BalanceToolbar = ({ className, config, ...rest }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const queryOptions = useSelector(
    config.selectors?.selectQueryOptions || (() => ({}))
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterValues, setFilterValues] = useState({});

  useEffect(() => {
    dispatch(config.actions.load());
    return () => dispatch({ type: config.clearActionType });
  }, [dispatch]);

  const handleClickFilter = useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleCloseFilter = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleFilterChange = useCallback(
    event => {
      setFilterValues(event);
      const filterOpts = getFilterOptions(event);
      const newOptions = {
        ...queryOptions,
        ...filterOpts,
        page: 0
      };

      dispatch(config.actions.load(newOptions));
    },
    [dispatch, queryOptions, config.actions]
  );

  const handleExcelExport = useCallback(() => {
    dispatch(config.actions.downloadExcel());
  }, [dispatch, config.actions]);

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Breadcrumb />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography style={{ fontWeight: '400' }} color="primary" variant="h1">
          {t(config.titleKey)}
        </Typography>
        <div className={classes.actionsContainer}>
          <Filter
            anchorEl={anchorEl}
            filterValues={filterValues}
            handleClose={handleCloseFilter}
            handleChange={handleFilterChange}
            filters={filters}
          />
          <Button
            className={clsx(
              classes.buttons,
              classes.outlined,
              classes.horizontalPadding
            )}
            color="primary"
            onClick={handleClickFilter}
          >
            <FilterList className={classes.icon} />
            {t('COMMON.FILTER')}
          </Button>
          <Button
            className={clsx(classes.buttons, classes.outlined)}
            onClick={handleExcelExport}
            color="primary"
          >
            <GetApp className={classes.icon} />
          </Button>
        </div>
      </div>
    </div>
  );
};

BalanceToolbar.propTypes = {
  className: PropTypes.string,
  config: PropTypes.shape({
    selectors: PropTypes.shape({
      selectQueryOptions: PropTypes.func
    }),
    actions: PropTypes.shape({
      load: PropTypes.func.isRequired,
      downloadExcel: PropTypes.func.isRequired
    }).isRequired,
    clearActionType: PropTypes.string.isRequired,
    titleKey: PropTypes.string.isRequired
  }).isRequired
};

export default BalanceToolbar;
